import { render } from "./appInactive.vue?vue&type=template&id=a42766ea"
import script from "./appInactive.vue?vue&type=script&lang=js"
export * from "./appInactive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__